
export const N19_TBL1 = [
      'ABW,Aruba',
      'AFG,Afghanistan',
      'AGO,Angola',
      'AIA,Anguilla',
      'ALB,Albania',
      'AND,Andorra',
      'ANT,Netherlands Antilles',
      'ARE,United Arab Emirates',
      'ARG,Argentina',
      'ASM,American Samoa',
      'ATA,Antarctica',
      'ATF,French Southern Territories',
      'ATG,Antigua and Barbuda',
      'ATN,See ATA',
      'AUS,Australia',
      'AUT,Austria',
      'BDI,Burundi',
      'BEL,Belgium',
      'BEN,Benin',
      'BFA,Burkina Faso',
      'BGD,Bangladesh',
      'BGR,Bulgaria',
      'BHR,Bahrain',
      'BHS,Bahamas',
      'BLZ,Belize',
      'BMU,Bermuda',
      'BOL,Bolivia',
      'BRA,Brazil',
      'BRB,Barbados',
      'BRN,Brunei Darussalam',
      'BTN,Bhutan',
      'BUR,Burma',
      'BVT,Bouvet Island',
      'BWA,Botswana',
      'BYS,Byelorussian SSR',
      'CAF,Central African Republic',
      'CAN,Canada',
      'CCK,Cocos (Keeling) Islands',
      'CHE,Switzerland',
      'CHL,Chile',
      'CHN,China',
      "CIV,Côte d'Ivoire",
      'CMR,Cameroon',
      'COG,Congo',
      'COK,Cook Islands',
      'COL,Colombia',
      'COM,Comoros',
      'CPV,Cape Verde',
      'CRI,Costa Rica',
      'CSK,Czechoslovakia',
      'CTE,See KIR',
      'CUB,Cuba',
      'CXR,Christmas Island',
      'CYM,Cayman Islands',
      'CYP,Cyprus IDN Indonesia',
      'DDR,German Democratic Republic',
      'DEU,Germany, Federal Republic of',
      'DHM,Kampuchea, Democratic',
      'DJI,Djibouti',
      'DMA,Dominica',
      'DNK,Denmark',
      'DOM,Dominican Republic',
      'DZA,Algeria',
      'ECU,Ecuador',
      'EGY,Egypt',
      'ESH,Western Sahara',
      'ESP,Spain',
      'ETH,Ethiopia',
      'FIN,Finland',
      'FJI,Fiji',
      'FLK,Falkland Islands (Malvinas)',
      'FRA,France',
      'FRO,Faroe Islands',
      'FSM,Micronesia',
      'GAB,Gabon',
      'GBR,United Kingdom',
      'GHA,Ghana',
      'GIB,Gibraltar',
      'GIN,Guinea',
      'GLP,Guadeloupe',
      'GMB,Gambia',
      'GNB,Guinea-Bissau',
      'GNQ,Equatorial Guinea',
      'GRC,Greece',
      'GRD,Grenada',
      'GRL,Greenland',
      'GTM,Guatemala',
      'GUF,French Guinea',
      'GUM,Guam',
      'GUY,Guyana',
      'HKG,Hong Kong',
      'HMD,Heard and Mc Donald Islands',
      'HND,Honduras',
      'HTI,Haiti',
      'HUN,Hungary',
      'HVO,See BFA',
      'IDN,India',
      'IDN,Indonesia',
      'IOT,British Indian Ocean Territory',
      'IRL,Ireland',
      'IRN,Iran',
      'IRQ,Iraq',
      'ISL,Iceland',
      'ISR,Israel',
      'ITA,Italy',
      'JAM,Jamaica',
      'JOR,Jordan',
      'JPN,Japan',
      'JTN,See UMI',
      'KEN,Kenya',
      'KIR,Kiribati',
      'KNA,Saint Kitts and Nevis',
      'KOR,Korea, Republic of',
      'KWT,Kuwait',
      "LAO,Lao, People's Democratic Republic of",
      'LBN,Lebanon',
      'LBR,Liberia',
      'LBY,Libyan Arab Jamahiriya',
      'LCA,Saint Lucia',
      'LIE,Liechtenstein',
      'LKA,Sri Lanka',
      'LSO,Lesotho',
      'LUX,Luxembourg',
      'MAC,Macau',
      'MAR,Morocco',
      'MCO,Monaco',
      'MDG,Madagascar',
      'MDV,Maldives',
      'MEX,Mexico',
      'MHL,Marshall Islands',
      'MID,See UMI',
      'MLI,Mali',
      'MLT,Malta',
      'MNG,Mongolia',
      'MNP,Nothern Mariana Islands',
      'MOZ,Mozambique',
      'MRT,Mauritania',
      'MSR,Montserrat',
      'MTQ,Martinique',
      'MUS,Mauritius',
      'MWI,Malawi',
      'MYS,Malaysia',
      'NAM,Namibia',
      'NCL,New Caledonia',
      'NER,Niger',
      'NFK,Norfolk Island',
      'NGA,Nigeria',
      'NIC,Nicaragua',
      'NIU,Niue',
      'NLD,Netherlands',
      'NOR,Norway',
      'NPL,Nepal',
      'NRU,Nauru',
      'NTZ,Neutral Zone',
      'NZL,New Zealand',
      'OMN,Oman',
      'OOO,escape code',
      'PAK,Pakistan',
      'PAN,Panama',
      'PCI,See FSM, MHL, MNP and PLW',
      'PCN,Pitcairn',
      'PER,Peru',
      'PHL,Philippines',
      'PLW,Palau',
      'PNG,Papua New Guinea',
      'POL,Poland',
      'PRI,Puerto Rico',
      "PRK,Korea, Democratic People's Republic of",
      'PRT,Portugal',
      'PRY,Paraguay',
      'PUS,See UMI',
      'PYF,French Polynesia',
      'QAT,Qatar',
      'REU,Réunion',
      'ROM,Romania',
      'RWA,Rwanda',
      'SAU,Saudi Arabia',
      'SDN,Sudan',
      'SEN,Senegal',
      'SGP,Singapore',
      'SHN,St. Helena',
      'SJM,Svalbard and Jan Mayen Islands',
      'SLB,Solomon Islands',
      'SLE,Sierra Leone',
      'SLV,El Salvador',
      'SMR,San Marino',
      'SOM,Somalia',
      'SPM,St. Pierre and Miquelon',
      'STP,Sao Tome and Principé',
      'SUN,USSR',
      'SUR,Surinam',
      'SWE,Sweden',
      'SWZ,Swaziland',
      'SYC,Seychelles',
      'SYR,Syrian Arab Republic',
      'TCA,Turks and Caicos Islands',
      'TCD,Chad',
      'TGO,Togo',
      'THA,Thailand',
      'TKL,Tokelau',
      'TMP,East Timor',
      'TON,Tonga',
      'TTO,Trinidad and Tobago',
      'TUN,Tunisia',
      'TUR,Turkey',
      'TUV,Tuvalu',
      'TWN,Taiwan, Province of China',
      'TZA,Tanzania, United Republic of',
      'UGA,Uganda',
      'UKR,Ukrainian',
      'UMI,United States Minor Outlying Islands',
      'URY,Uruguay',
      'USA,United States',
      'VAT,Vatican City State',
      'VCT,Saint Vincent and the Grenadines',
      'VEN,Venezuela',
      'VGB,Virgin Islands (British)',
      'VIR,Virgin Islands (U.S.)',
      'VNM,Viet Nam',
      'VUT,Vanuatu',
      'WAK,See UMI',
      'WLF,Wallis and Futuna Islands',
      'WSM,Samoa',
      'YEM,Yemen',
      'YMD,Yemen, Democratic',
      'YUG,Yugoslavia',
      'ZAF,South Africa',
      'ZAR,Zaire',
      'ZMB,Zambia',
      'ZWE,Zimbabwe',
      ]

export const N19_TBL2 = [
     '00,Unknown/not,applicable',
     '01,Albanian',
     '02,Breton',
     '03,Catalan',
     '04,Croatian',
     '05,Welsh',
     '06,Czech',
     '07,Danish',
     '08,German',
     '09,English',
     '0A,Spanish',
     '0B,Esperanto',
     '0C,Estonian',
     '0D,Basque',
     '0E,Faroese',
     '0F,French',
     '10,Frisian',
     '11,Irish',
     '12,Gaelic',
     '13,Galician',
     '14,Icelandic',
     '15,Italian',
     '16,Lappish',
     '17,Latin',
     '18,Latvian',
     '19,Luxembourgian',
     '1A,Lithuania',
     '1B,Hungarian',
     '1C,Maltese',
     '1D,Dutch',
     '1E,Norwegian',
     '1F,Occitan',
     '20,Polish',
     '21,Portugese',
     '22,Romanian',
     '23,Romansh',
     '24,Serbian',
     '25,Slovak',
     '26,Slovenian',
     '27,Finnish',
     '28,Swedish',
     '29,Turkish',
     '2A,Flemish',
     '2B,Wallon',
     '2F,Reservé',
     '45,Zulu',
     '46,Vietnamese',
     '47,Uzbek',
     '48,Urdu',
     '49,Ukrainian',
     '4A,Thai',
     '4B,Telugu',
     '4C,Tatar',
     '4D,Tamil',
     '4E,Tadzhik',
     '4F,Swahili',
     '50,Sranan,Tongo',
     '51,Somali',
     '52,Sinhalese',
     '53,Shona',
     '54,Serbo-croat',
     '55,Ruthenian',
     '56,Russian',
     '57,Quechua',
     '58,Pushtu',
     '59,Punjabi',
     '5A,Persian',
     '5B,Papamiento',
     '5C,Oriya',
     '5D,Nepali',
     '5E,Ndebele',
     '5F,Marathi',
     '60,Moldavian',
     '61,Malaysian',
     '62,Malagasay',
     '63,Macedonian',
     '64,Laotian',
     '65,Korean',
     '66,Khmer',
     '67,Kazakh',
     '68,Kannada',
     '69,Japanese',
     '6A,Indonesian',
     '6B,Hindi',
     '6C,Hebrew',
     '6D,Hausa',
     '6E,Gurani',
     '6F,Gujurati',
     '70,Greek',
     '71,Georgian',
     '72,Fulani',
     '73,Dari',
     '74,Churash',
     '75,Chinese',
     '76,Burmese',
     '77,Bulgarian',
     '78,Bengali',
     '79,Bielorussian',
     '7A,Bambora',
     '7B,Azerbaijani',
     '7C,Assamese',
     '7D,Armenian',
     '7E,Arabic',
     '7F,Amharic',
      ]

export const N19_TBL3 = [      

      '437,U.S.A.',
      '850,International',
      '860,Portugal',
      '863,French/Canada',
      '865,Novergian',
      ]
export const N19_TBL4 = [
      '00,Latin 6937/2-1983',
      '01,Latin Cyrillic 8859/2-1988',
      '02,Latin Arabic 8859/2-1987',
      '03,Latin Greek 8859/2-1987',
      '04,hebrew 8859/2-1988',

      ]
    




